import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const TaylorsSeries = () => (
  <QPhototModuleSubtopic
    title="Taylor's series"
    videos={[
      "https://www.youtube.com/embed/1c5mCr8QFRA",
      "https://www.youtube.com/embed/eLcOqk9VGps",
      "https://www.youtube.com/embed/6oKKawvGpc4"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_27.jpeg"
        },
        {
            image:"/cal_28.jpeg"
        },
        {
            image:"/cal_29.jpeg"
        },
        {
            image:"/cal_30.jpeg"
        },
        {
            image:"/cal_31.jpeg"
        },
        {
            image:"/cal_32.jpeg"
        },
        {
            image:"/cal_33.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default TaylorsSeries;
